module.exports = __webpack_public_path__ + "img/banner02.561b66ef.webp";